export default __webpack_public_path__ + "8609c54313a0c4caaa541286820952c9.png";